"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setTwoFactorRequired = exports.SetTwoFactorRequired = exports.SetTwoFactorRequiredActionTypes = exports.setTwoFactorNotRequired = exports.SetTwoFactorNotRequired = exports.SetTwoFactorNotRequiredActionTypes = exports.loadTwoFactorRequiredSettings = exports.FetchTwoFactorRequiredEnforcement = exports.FetchTwoFactorRequiredEnforcementActionTypes = exports.TwoFactorAuthActionTypes = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _fluxActions = require("flux-actions");

var _I18n = _interopRequireDefault(require("I18n"));

var _RequestStatusTypes = _interopRequireDefault(require("settings-ui-lib/constants/RequestStatusTypes"));

var _actions = require("settings-ui-lib/utils/actions");

var _namespacedKeyMirror = _interopRequireDefault(require("settings-ui-sdk/utils/namespacedKeyMirror"));

var TwoFactorAuthActionTypes = (0, _namespacedKeyMirror.default)({
  FETCH_TWO_FACTOR_REQUIRED_ENFORCEMENT: null,
  SET_TWO_FACTOR_NOT_REQUIRED: null,
  SET_TWO_FACTOR_REQUIRED: null
}, 'twoFactorAuth');
exports.TwoFactorAuthActionTypes = TwoFactorAuthActionTypes;
var FetchTwoFactorRequiredEnforcementActionTypes = (0, _actions.createRequestTypes)(TwoFactorAuthActionTypes.FETCH_TWO_FACTOR_REQUIRED_ENFORCEMENT);
exports.FetchTwoFactorRequiredEnforcementActionTypes = FetchTwoFactorRequiredEnforcementActionTypes;
var FetchTwoFactorRequiredEnforcement = (0, _actions.createRequestActions)(FetchTwoFactorRequiredEnforcementActionTypes, {
  failureMetaCreator: function failureMetaCreator() {
    return (0, _extends2.default)({}, (0, _actions.createRequestStatusMeta)(FetchTwoFactorRequiredEnforcementActionTypes.base, _RequestStatusTypes.default.FAILED), (0, _actions.createDangerNotificationMeta)(_I18n.default.text('accountdefaults.security.twoFactorAuth.notifications.fetchError')));
  }
});
exports.FetchTwoFactorRequiredEnforcement = FetchTwoFactorRequiredEnforcement;
var loadTwoFactorRequiredSettings = (0, _fluxActions.createAction)(TwoFactorAuthActionTypes.FETCH_TWO_FACTOR_REQUIRED_ENFORCEMENT);
exports.loadTwoFactorRequiredSettings = loadTwoFactorRequiredSettings;
var SetTwoFactorNotRequiredActionTypes = (0, _actions.createRequestTypes)(TwoFactorAuthActionTypes.SET_TWO_FACTOR_NOT_REQUIRED);
exports.SetTwoFactorNotRequiredActionTypes = SetTwoFactorNotRequiredActionTypes;
var SetTwoFactorNotRequired = (0, _actions.createRequestActions)(SetTwoFactorNotRequiredActionTypes, {
  failureMetaCreator: function failureMetaCreator() {
    return (0, _extends2.default)({}, (0, _actions.createRequestStatusMeta)(SetTwoFactorNotRequiredActionTypes.base, _RequestStatusTypes.default.FAILED), (0, _actions.createDangerNotificationMeta)(_I18n.default.text('accountdefaults.security.twoFactorAuth.notifications.saveError')));
  }
});
exports.SetTwoFactorNotRequired = SetTwoFactorNotRequired;
var setTwoFactorNotRequired = (0, _fluxActions.createAction)(TwoFactorAuthActionTypes.SET_TWO_FACTOR_NOT_REQUIRED);
exports.setTwoFactorNotRequired = setTwoFactorNotRequired;
var SetTwoFactorRequiredActionTypes = (0, _actions.createRequestTypes)(TwoFactorAuthActionTypes.SET_TWO_FACTOR_REQUIRED);
exports.SetTwoFactorRequiredActionTypes = SetTwoFactorRequiredActionTypes;
var SetTwoFactorRequired = (0, _actions.createRequestActions)(SetTwoFactorRequiredActionTypes, {
  failureMetaCreator: function failureMetaCreator() {
    return (0, _extends2.default)({}, (0, _actions.createRequestStatusMeta)(SetTwoFactorRequiredActionTypes.base, _RequestStatusTypes.default.FAILED), (0, _actions.createDangerNotificationMeta)(_I18n.default.text('accountdefaults.security.twoFactorAuth.notifications.saveError')));
  }
});
exports.SetTwoFactorRequired = SetTwoFactorRequired;
var setTwoFactorRequired = (0, _fluxActions.createAction)(TwoFactorAuthActionTypes.SET_TWO_FACTOR_REQUIRED);
exports.setTwoFactorRequired = setTwoFactorRequired;